import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
const UploadLabel = styled.label `
  color: ${({ theme, disabled }) => (disabled ? theme.colors.grey70_1 : theme.colors.link100)};
  cursor: pointer;
`;
export const UploadInput = ({ onFileAdd, disabled, uploadButtonText, multiple, inputRef, }) => {
    const onFileInputChange = useCallbackRef((e) => {
        const { files } = e.target;
        if (files) {
            for (const file of files) {
                onFileAdd(file);
            }
        }
    });
    return uploadButtonText ? (_jsxs(UploadLabel, { disabled: disabled, children: [_jsx("input", { ref: inputRef, type: 'file', hidden: true, disabled: disabled, onChange: onFileInputChange, multiple: multiple }), uploadButtonText] })) : null;
};
